'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { Box, CircularProgress, Typography } from '@matteoaliano/forest-ui';
import { useTenant } from '@/contexts/TenantContext';

// Root entry. TenantContext picks the user's default tenant (last used /
// email-derived / first available) — redirect there so every subsequent
// link can be slug-prefixed. A user the enrollment policy left without any
// tenant lands here with an empty list: show a "no access" state instead of
// an endless spinner.
export default function RootRedirect() {
  const router = useRouter();
  const { currentTenant, realTenants, isLoading } = useTenant();

  useEffect(() => {
    if (isLoading) return;
    if (currentTenant?.slug) {
      router.replace(`/${currentTenant.slug}/dashboard`);
    }
  }, [currentTenant?.slug, isLoading, router]);

  if (!isLoading && realTenants.length === 0) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          gap: 2,
          height: '60vh',
          px: 3,
        }}
      >
        <Typography variant="h5">Nessun accesso</Typography>
        <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 420 }}>
          Il tuo account non ha ancora accesso a nessuna business unit. Contatta
          un amministratore per richiedere l&apos;accesso.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh' }}>
      <CircularProgress aria-label="Loading" />
    </Box>
  );
}
